module.exports = __webpack_public_path__ + "static/media/view3.2bbaf2c6.jpg";